<template>
  <div class="rule" :class="cssType">
    <div class="rule-title" :class="locale"></div>
    <div class="rule-content" :class="locale">
      <div class="rule-content-part" v-for="text in ruleTexts" :key="text">
        <div v-for="text in splitText(text)" :key="text" v-html="text"></div>
        <br />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { isMobile } from '@/utils'
import { useI18n } from 'vue-i18n'
const { locale, t } = useI18n()
const cssType = isMobile ? 'mobile' : 'pc'
const payUrl = computed(() => {
  return process.env.VUE_APP_HISTORY_URL + locale.value
})
const ruleTexts = computed(() => {
  const text = t('sf.rule.content')
  const texts = text.split('\n')
  const textList = texts.map(text => {
    if (text.includes('[goRecharge]')) {
      text = text.replace('[goRecharge]', `
      <a href="${payUrl.value}" class="cny-link-yellow" target="_blank">
        [${t('cny.goRecharge')}]
      </a>
      `)
    }
    return text
  })
  return textList
})
const splitText = (text) => {
  console.log(text.split('\t'))
  return text.split('\t')
}

</script>

<style lang="less" scoped src="./pc_style.less"></style>
<style lang="less" scoped src="./mobile_style.less"></style>